export function parseOrDefault(value, defaultValue) {
    if (!value) {
        return defaultValue;
    }
    try {
        return JSON.parse(value ?? '');
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (error) {
        return defaultValue;
    }
}
export function deepCopy(value) {
    return JSON.parse(JSON.stringify(value));
}
